import PropTypes from 'prop-types';
import './BrandCancellationsPreviewTable.scss';

import { formatDateOnlyET } from '../../helpers/brand_cancellation_helpers';

const BrandCancellationsPreviewTable = ({ table, columns }) => {
  if (!table?.count) return null;
  return (
    <div className='brand-cancellations-preview-table-wrapper'>
      <table className='brand-cancellations-preview-table'>
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, idx) => (
            <tr key={row.id ?? idx}>
              {columns.map(col => (
                <td key={col}>{formatCell(row[col])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {table.count > table.rows.length && <div className='brand-cancellations-preview-more'>…and {table.count - table.rows.length} more</div>}
    </div>
  );
};

const formatCell = value => {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)) return formatDateOnlyET(value);
  return String(value);
};

BrandCancellationsPreviewTable.propTypes = {
  table: PropTypes.shape({
    count: PropTypes.number,
    rows: PropTypes.array
  }),
  columns: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default BrandCancellationsPreviewTable;
